import { FC, ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';
import PdpSharedCustomsMessage from './PdpSharedCustomsMessage';
import { PdpSharedShippingInfo } from './PdpSharedShippingInfo';

import styles from './PdpSharedShippingInfo.scss';

import { PdpSharedShippingInfoWrapper_item$key } from './__generated__/PdpSharedShippingInfoWrapper_item.graphql';
import { PdpSharedShippingInfoWrapper_user$key } from './__generated__/PdpSharedShippingInfoWrapper_user.graphql';

type Props = {
    item: PdpSharedShippingInfoWrapper_item$key;
    user: PdpSharedShippingInfoWrapper_user$key;
    currency: string;
    children?: ReactNode;
    leadTime?: string | null;
    renderTooltip?: boolean;
    showCustomsInfo?: boolean;
    isClient?: boolean;
    title?: ReactNode;
    displayInline?: boolean;
    preLinkQuoteDetails?: ReactNode;
    postLinkQuoteDetails?: ReactNode;
    postLinkNoQuoteDetails?: ReactNode;
    hidePaidShipping?: boolean;
};

const PdpSharedShippingInfoWrapper: FC<Props> = ({
    item: itemRef,
    user: userRef,
    currency,
    children,
    leadTime,
    renderTooltip,
    showCustomsInfo,
    isClient = false,
    title,
    displayInline,
    preLinkQuoteDetails,
    postLinkQuoteDetails,
    postLinkNoQuoteDetails,
    hidePaidShipping,
}) => {
    const user = useFragment(
        graphql`
            fragment PdpSharedShippingInfoWrapper_user on User {
                serviceId
                isVerifiedTrade
            }
        `,
        userRef
    );
    const item = useFragment(
        graphql`
            fragment PdpSharedShippingInfoWrapper_item on Item {
                serviceId
                ...PdpSharedCustomsMessage_item
            }
        `,
        itemRef
    );

    return (
        <span className={styles.shippingInfoContainer}>
            <PdpSharedShippingInfo
                renderTooltip={renderTooltip}
                currency={currency}
                leadTime={leadTime || ''}
                itemId={item?.serviceId || ''}
                userId={user?.serviceId || ''}
                isTrade={user?.isVerifiedTrade || false}
                title={title}
                displayInline={displayInline}
                preLinkQuoteDetails={preLinkQuoteDetails}
                postLinkQuoteDetails={postLinkQuoteDetails}
                postLinkNoQuoteDetails={postLinkNoQuoteDetails}
                isClient={isClient}
                hidePaidShipping={hidePaidShipping}
            />
            {children}
            {showCustomsInfo && <PdpSharedCustomsMessage item={item} isClient={isClient} />}
        </span>
    );
};

export default PdpSharedShippingInfoWrapper;
